import { render } from "./company-lists-empty.vue?vue&type=template&id=5a70dfbb&scoped=true&ts=true"
import script from "./company-lists-empty.vue?vue&type=script&lang=ts"
export * from "./company-lists-empty.vue?vue&type=script&lang=ts"

import "./company-lists-empty.vue?vue&type=style&index=0&id=5a70dfbb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a70dfbb"]])

export default __exports__